const routes = [{
  path: '/personnel/register',
  component: () => import('@/views/personnel/register'),
  name: 'personnel/register',
  meta: {
    title: '增员审批'
  }
}, {
  path: '/personnel/management',
  component: () => import('@/views/personnel/management'),
  name: 'personnel/management',
  meta: {
    title: '入职管理'
  }
}, {
  path: '/personnel/contract',
  component: () => import('@/views/personnel/contract'),
  name: 'personnel/contract',
  meta: {
    title: '用工合同'
  }
}, {
  path: '/personnel/practice',
  component: () => import('@/views/personnel/practice'),
  name: 'personnel/practice',
  meta: {
    title: '执业登记'
  }
}, {
  path: '/personnel/information',
  component: () => import('@/views/personnel/information'),
  name: 'personnel/information',
  meta: {
    title: '人员列表'
  }
}, {
  path: '/personnel/salesList',
  component: () => import('@/views/personnel/salesList'),
  name: 'personnel-salesList',
  meta: {
    title: '人员列表(新)'
  }
}, {
  path: '/personnel/dimission',
  component: () => import('@/views/personnel/dimission'),
  name: 'personnel/dimission',
  meta: {
    title: '离职管理'
  }
}, {
  path: '/personnel/again',
  component: () => import('@/views/personnel/again'),
  name: 'personnel/again',
  meta: {
    title: '二次入司'
  }
}, {
  path: '/personnel/track',
  component: () => import('@/views/personnel/track'),
  name: 'personnel/track',
  meta: {
    title: '异动轨迹'
  }
}, {
  path: '/personnel/addPersonnel',
  component: () => import('@/views/personnel/addPersonnel'),
  name: 'personnel/addPersonnel',
  meta: {
    title: '人员新增'
  }
}, {
  path: '/personnel/addSales',
  component: () => import('@/views/personnel/addSales'),
  name: 'personnel/addSales',
  meta: {
    title: ''
  }
}, {
  path: '/personnel/salesDetail',
  component: () => import('@/views/personnel/salesDetail'),
  name: 'personnel/salesDetail',
  meta: {
    title: '人员管理/人员列表/详情'
  }
}, {
  path: '/personnel/attestation',
  component: () => import('@/views/personnel/attestation'),
  name: 'personnel/attestation',
  meta: {
    title: '注册认证审批'
  }
}, {
  path: '/personnel/attestationNew',
  component: () => import('@/views/personnel/attestationNew'),
  name: 'personnel/attestationNew',
  meta: {
    title: '注册认证审批(新)'
  }
}, {
  path: '/personnel/batchArrangeList',
  component: () => import('@/views/personnel/batchArrangeList'),
  name: 'personnel/batchArrangeList',
  meta: {
    title: '批量上编任务列表'
  }
}, {
  path: '/personnel/batchMessageList',
  component: () => import('@/views/personnel/batchMessageList'),
  name: 'personnel/batchMessageList',
  meta: {
    title: '人员批量导入任务列表'
  }
}, {
  path: '/personnel/contractTemplate',
  component: () => import('@/views/personnel/contractTemplate'),
  name: 'personnel/contractTemplate',
  meta: {
    title: '合同模板维护列表'
  }
}, {
  path: '/personnel/contractCompile',
  component: () => import('@/views/personnel/contractCompile'),
  name: 'personnel/contractCompile',
  meta: {
    title: '合同新增/编辑'
  }
}, {
  path: '/personnel/setting',
  component: () => import('@/views/personnel/setting'),
  name: 'personnel/setting',
  meta: {
    title: '移动端报价配置'
  }
}, {
  path: '/personnel/personnelStatistics',
  component: () => import('@/views/personnel/personnelStatistics'),
  name: 'personnel/personnelStatistics',
  meta: {
    title: '人员统计'
  }
}, {
  path: '/personnel/certificationSetting',
  component: () => import('@/views/personnel/certificationSetting'),
  name: 'personnel/certificationSetting',
  meta: {
    title: '入职认证设置'
  }
}, {
  path: '/personnel/label',
  component: () => import('@/views/personnel/label/index'),
  name: 'personnel/label',
  meta: {
    title: '标签管理'
  }
}, {
  path: '/personnel/jobNumRuleSetting',
  component: () => import('@/views/personnel/jobNumRuleSetting'),
  name: 'personnel/jobNumRuleSetting',
  meta: {
    title: '工号规则设置'
  }
}]
export default routes



// WEBPACK FOOTER //
// ./src/router/human/personnel.js